import React from 'react';
import MainLayout from '../components/MainLayout';

export default function PackageManagementDis() {
  return (
    <>
    <MainLayout>

    <div className='container'>

        <div className='row'>
        <div className='col-12'>
        PackageManagementDis
        </div>
        </div>

    </div>

    </MainLayout>
    </>
  )
}
